import React, { useState } from 'react';

const UserPosts = () => {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [imageFile, setImageFile] = useState(null);
  const [posts, setPosts] = useState([]);
  const [currentUser] = useState({ id: 1, username: 'CurrentUser' });

  const createPost = () => {
    if (!title || !description) return;

    const newPost = {
      id: posts.length + 1,
      userId: currentUser.id,
      title,
      description,
      image: imageFile,
      likes: [],
      comments: [],
    };

    setPosts([...posts, newPost]);
    setTitle('');
    setDescription('');
    setImageFile(null);

    // In a real application, you should send the post to your server using an API call here
    // Example: createNewPost(newPost);
  };

  return (
    <div className="user-posts-container">
      <h2>Create a Post</h2>
      <div className="post-input">
        <input
          type="text"
          placeholder="Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <textarea
          placeholder="Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
        <input
          type="file"
          accept="image/*"
          onChange={(e) => setImageFile(e.target.files[0])}
        />
        <button onClick={createPost}>Create Post</button>
      </div>
      <div className="post-feed">
        <h2>User Posts</h2>
        <ul>
          {posts.map((post) => (
            <li key={post.id}>
              <h3>{post.title}</h3>
              <p>{post.description}</p>
              {post.image && <img src={URL.createObjectURL(post.image)} alt={post.title} />}
              <button>Like</button>
              <button>Comment</button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default UserPosts;
